/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import { websiteUrl } from "./config";

const awsconfig = {
  aws_project_region: import.meta.env.VITE_AWS_PROJECT_REGION
    ? import.meta.env.VITE_AWS_PROJECT_REGION
    : "ap-southeast-1",
    aws_cognito_identity_pool_id: import.meta.env
    .VITE_AWS_COGNITO_IDENTITY_POOL_ID
    ? import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID
    : "ap-southeast-1:9a5331da-329a-497d-be61-15668b42bf8f",
  aws_appsync_graphqlEndpoint: import.meta.env.VITE_AWS_APPSYNC_GRAPHQLENDPOINT
    ? import.meta.env.VITE_AWS_APPSYNC_GRAPHQLENDPOINT
    : "https://dev-sponsor-api.konfhub.com/graphql",
  aws_appsync_region: import.meta.env.VITE_AWS_COGNITO_REGION
    ? import.meta.env.VITE_AWS_COGNITO_REGION
    : "ap-southeast-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-wi4lunfqyncudic6b6itpormmm",
  aws_cognito_region: import.meta.env.VITE_AWS_COGNITO_REGION
    ? import.meta.env.VITE_AWS_COGNITO_REGION
    : "ap-southeast-1",
  aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID
    ? import.meta.env.VITE_AWS_USER_POOLS_ID
    : "ap-southeast-1_f6tfrmIsS",
  aws_user_pools_web_client_id: import.meta.env
    .VITE_AWS_USER_POOLS_WEB_CLIENT_ID
    ? import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID
    : "1cum79568pe0u434ek1d5kin9a",
  authenticationFlowType:
  "USER_SRP_AUTH" | "USER_PASSWORD_AUTH" | "CUSTOM_AUTH",
  oauth: {
    domain: import.meta.env.VITE_AWS_DOMAIN
      ? import.meta.env.VITE_AWS_DOMAIN
      : "dev-auth.konfhub.com",
    scope: [
      "aws.cognito.signin.user.admin",
      "email",
      "openid",
      "phone",
      "profile",
    ],
    redirectSignIn: websiteUrl,
    redirectSignOut: websiteUrl,
    responseType: "code",
  },
  cookieStorage: {
    domain: import.meta.env.VITE_HOST_NAME || "localhost",
    secure: true,
    path: "/",
    expires: 365,
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["FACEBOOK", "GOOGLE", "AMAZON"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 6,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsconfig;
